import "@/App.css";
import "./i18n";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import ProjectBuilder from "./pages/ProjectBuilder";
import Proposal from "./pages/Proposal";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProjectDetail from "./pages/AdminProjectDetail";
import AdminFinance from "./pages/AdminFinance";
import AdminPromoters from "./pages/AdminPromoters";
import AdminPromoterMaterials from "./pages/AdminPromoterMaterials";
import AdminInviteAccept from "./pages/AdminInviteAccept";
import AdminSettings from "./pages/AdminSettings";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminSEO from "./pages/AdminSEO";
import SEOHead from "./components/SEOHead";
import BackToTop from "./components/BackToTop";
import CustomerLogin from "./pages/CustomerLogin";
import MagicVerify from "./pages/MagicVerify";
import CustomerDashboard from "./pages/CustomerDashboard";
import CustomerProjectDetail from "./pages/CustomerProjectDetail";
import PromoterLogin from "./pages/PromoterLogin";
import PromoterVerify from "./pages/PromoterVerify";
import PromoterDashboard from "./pages/PromoterDashboard";
import PromoterApply from "./pages/PromoterApply";
import Promoters from "./pages/Promoters";
import NotFound from "./pages/NotFound";
import RapidMVPDevelopment from "./pages/seo/RapidMVPDevelopment";
import MVPDevelopmentForStartups from "./pages/seo/MVPDevelopmentForStartups";
import FixedPriceMVPDevelopment from "./pages/seo/FixedPriceMVPDevelopment";
import Pricing from "./pages/seo/Pricing";
import GuideMVPDevelopmentCost from "./pages/seo/GuideMVPDevelopmentCost";
import GuideHowLongMVP from "./pages/seo/GuideHowLongMVP";
import GuidePrototypeVsPocVsMVP from "./pages/seo/GuidePrototypeVsPocVsMVP";
import About from "./pages/About";
import Legal from "./pages/Legal";
import TrackProject from "./pages/TrackProject";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import CookieConsent from "./components/CookieConsent";
import { initAnalytics, lfTrackPageView } from "./lib/analytics";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { lfTrackPageView(location.pathname); }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/build" element={<ProjectBuilder />} />
      <Route path="/proposal/:projectId" element={<Proposal />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/finance" element={<ProtectedRoute><AdminFinance /></ProtectedRoute>} />
      <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
      <Route path="/admin/seo" element={<ProtectedRoute><AdminSEO /></ProtectedRoute>} />
      <Route path="/admin/promoters" element={<ProtectedRoute><AdminPromoters /></ProtectedRoute>} />
      <Route path="/admin/promoter-materials" element={<ProtectedRoute><AdminPromoterMaterials /></ProtectedRoute>} />
      <Route path="/admin/projects/:projectId" element={<ProtectedRoute><AdminProjectDetail /></ProtectedRoute>} />
      <Route path="/admin/accept/:token" element={<AdminInviteAccept />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/track" element={<TrackProject />} />
      <Route path="/track/:projectId" element={<TrackProject />} />
      <Route path="/customer/login" element={<CustomerLogin />} />
      <Route path="/magic/:token" element={<MagicVerify />} />
      <Route path="/dashboard" element={<CustomerDashboard />} />
      <Route path="/dashboard/projects/:projectId" element={<CustomerProjectDetail />} />
      <Route path="/promoters" element={<Promoters />} />
      <Route path="/promoter" element={<PromoterLogin />} />
      <Route path="/promoter/login" element={<PromoterLogin />} />
      <Route path="/promoter/apply" element={<PromoterApply />} />
      <Route path="/promoter/verify/:token" element={<PromoterVerify />} />
      <Route path="/promoter/dashboard" element={<PromoterDashboard />} />
      <Route path="/rapid-mvp-development" element={<RapidMVPDevelopment />} />
      <Route path="/mvp-development-for-startups" element={<MVPDevelopmentForStartups />} />
      <Route path="/fixed-price-mvp-development" element={<FixedPriceMVPDevelopment />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/guides/mvp-development-cost" element={<GuideMVPDevelopmentCost />} />
      <Route path="/guides/how-long-does-an-mvp-take" element={<GuideHowLongMVP />} />
      <Route path="/guides/prototype-vs-poc-vs-mvp" element={<GuidePrototypeVsPocVsMVP />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <AppRouter />
        <CookieConsent />
        <BackToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;
